import { app } from '../../../../app';

app.component('userProfile', {
    bindings: {profile: '<'},
    templateUrl: require('./profile.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/user/profiles/profile/profile.component.js